module.exports = __webpack_public_path__ + "img/si.14651cb5.png";